import { ApiError } from '@community_dev/requests'
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

import { CommunityRegistrationResponse, getCommunityRegistrations } from 'api/tcr'
import { QUERIES } from 'constants/queries'

export function useCommunityTCRRegistrationQuery<SelectData = CommunityRegistrationResponse>(
  clientId: string,
  options: UseQueryOptions<CommunityRegistrationResponse, ApiError, SelectData> = {},
): UseQueryResult<SelectData, ApiError> {
  return useQuery({
    queryKey: [QUERIES.TCR.COMMUNITY_REGISTRATIONS, clientId],
    queryFn: () => getCommunityRegistrations(clientId),
    ...options,
  })
}
